<app-window-title title="Hospital's library"
                  [closable]="true"></app-window-title>
<div  class="fx-col">
  <app-filter-search *ngIf="categories"
                     [categories]="categories"
                     (filter)="handlePatientFilterFiles($event)"
                     (search)="handlePatientSearchFiles($event)">
  </app-filter-search>
  <mat-card id="generalLibraryList"
            class="no-select panel target-panel fx-flex-100pct fx-col fx-jc-start fx-ai-stretch"  [cdkDropListData]="generalLibraryList">
    <mat-card-title>
      General
    </mat-card-title>
    <div class="file-items-grid">
      <div *ngFor="let item of generalLibraryList; let i = index"
           (click)="toggleSelection(item, i, 'target1')">
        <div class="file-item"
             [class.selected]="isSelected(item, 'target1')">
          <mat-icon (dblclick)="openFile(item)">
            {{ item.icon }}
          </mat-icon>
          {{ item.filename }} - {{ item.filesize }}
        </div>
      </div>
    </div>

    <div class="sticky-buttons fx-row fx-jc-end fx-ai-center fx-gap-10"  >
      <button color="warn"
              mat-raised-button
              (click)="uploadFiles()">
        Upload files
        <mat-icon>
          cloud_upload
        </mat-icon>
      </button>
      <button *ngIf="selectedItemsTarget1.size > 0"
              color="warn"
              mat-raised-button
              (click)="deleteFiles(selectedItemsTarget1)">
        Delete selected
        <mat-icon>
          delete
        </mat-icon>
      </button>
    </div>
  </mat-card>
</div>
